import { IField } from 'app/services/api5-service/api.interface';

import { ISPFieldConfig, ISPFieldType } from '../../model';

/**
 * Get original field metadata. if it can be extracted, from field config
 *
 * @param config - field config
 */
export function getOriginalFieldFromConfig(
  config: ISPFieldConfig,
): IField | undefined {
  if (config.type === ISPFieldType.Group && config.fieldGroup.length > 0) {
    const firstConfig = config.fieldGroup[0];
    if ('originalField' in firstConfig.props) {
      return firstConfig.props.originalField;
    }
  } else if ('originalField' in config.props) {
    return config.props.originalField;
  }
  return undefined;
}
